export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
export const DEFAULT_DATE_TIME_FORMAT = 'MM/DD/YYYY hh:mm A';
